import * as React from 'react'
import { connect } from 'react-redux'
import { Title } from '../../components/pageTitle/title'
import {
  metaDataSelector,
  seasonsSelector,
  synopsisSelector,
  titleComponentSelector,
  heroShotSelector,
  atfCriticalDataSelector,
  liveStateDataSelector,
  renderOnlyGen4PlaybackInAtfSelector
} from '../../selectors/component/atfComponentSelectors'
import { AtfSynopsis } from '../../components/synopsis/synopsis'
import { Seasons } from '../../components/seasonSelector/seasons'
import { Badges } from './badgesComponent'
import { ActionBox } from './actionBox'
import { Heroshot } from '../../components/heroshot/heroshot'
import * as st from './atfComponent.module.scss'
import { AtfProductMetaInfo } from '../../components/productMetaInfo/atfProductMetaInfo'
import { OnlyPlaybackAvailableInGen4Message, PageUnavailable } from '../../components/pageUnavailable/pageUnavailable'
import { IDetailPageState } from '../../reducers'
import { LiveState } from '../../components/liveState/liveState'
import { PlayerIntegration } from '../../integrations/playerIntegration'
import { BannerPromo } from '../../components/creative/bannerPromo/bannerPromo'
import { bannerPromoSelector, heroQuickPromoSelector } from '../../selectors/creative'
import { HeroQuickPromo } from '../../components/creative/heroQuickPromo/heroQuickPromo'
import { BundleCarousel } from '../../components/bundleCarousel/bundleCarousel'
import { pageSelectors } from '../../selectors/basicState'
import { CrowBanner } from '../../components/crowBanner/crowBanner'
import { crowBannerSelector } from '../../selectors/crowBanner'
import { blockedPageSelector } from '../../selectors/component/pageBlockComponentSelectors'
import { PageBlock } from '../../components/pageBlock/pageBlock';
import { BannerContainer } from '../../components/bannerContainer/bannerContainer'
import { UiBanner } from '../../components/uiBanner/uiBanner'
import { sanitizedRequestContextSelector } from '../../selectors/requestContext'

type Props = ReturnType<typeof mapStateToProps>

const Atf = ({
  hasCritical,
  renderOnlyGen4PlaybackInAtf,
  title,
  heroshot,
  metaData,
  synopsis,
  seasons,
  liveState,
  bannerPromo,
  heroQuickPromo,
  bundleCarousel,
  crowBanner,
  blockedPage,
  isRetail,
}: Props) => {
  if (blockedPage) {
    return (
      <div className={'av-detail-section'}>
        <PageBlock {...blockedPage} />
      </div>
    )
  }
  if (!hasCritical) {
    return (
      <div className={'av-detail-section'}>
        <div className={st.atfContainer}>
          <PageUnavailable />
        </div>
      </div>
    )
  }
  return (
    <>
      <BannerContainer isRetail={isRetail}>
        {crowBanner && <CrowBanner {...crowBanner} />}
        <UiBanner />
      </BannerContainer>
      {bannerPromo && <BannerPromo {...bannerPromo} />}
      {heroshot && <Heroshot {...heroshot} />}
      <div className={'av-detail-section'}>
        <div className={st.atfContainer}>
          {renderOnlyGen4PlaybackInAtf && (
            <OnlyPlaybackAvailableInGen4Message />
          )}
          {liveState && <LiveState {...liveState} />}
          <Title {...title} />
          {seasons && <Seasons {...seasons} />}
          <Badges />
          {synopsis && <AtfSynopsis {...synopsis} />}
          {metaData && <AtfProductMetaInfo {...metaData} />}
          <ActionBoxWrapper />
          {heroQuickPromo && <HeroQuickPromo {...heroQuickPromo} />}
        </div>
      </div>
      {bundleCarousel && <BundleCarousel {...bundleCarousel} />}
      <PlayerIntegration />
    </>
  )
}

const ActionBoxWrapper = () =>
  <div id="dv-action-box-wrapper" className="avu-full-width" >
    <div id="dv-action-box" className="js-dv-action-box avu-full-width-phablet">
      <ActionBox />
    </div>
  </div>

const mapStateToProps = (state: IDetailPageState) => {
  return {
    hasCritical: atfCriticalDataSelector(state),
    renderOnlyGen4PlaybackInAtf: renderOnlyGen4PlaybackInAtfSelector(state),
    title: titleComponentSelector(state),
    heroshot: heroShotSelector(state),
    metaData: metaDataSelector(state),
    synopsis: synopsisSelector(state),
    seasons: seasonsSelector(state),
    liveState: liveStateDataSelector(state),
    bannerPromo: bannerPromoSelector(state),
    heroQuickPromo: heroQuickPromoSelector(state),
    bundleCarousel: pageSelectors.bundleCarousel(state),
    crowBanner: crowBannerSelector(state),
    blockedPage: blockedPageSelector(state),
    isRetail: sanitizedRequestContextSelector(state).isRetail
  }
}

export const AtfComponent = connect(mapStateToProps)(Atf)


